import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.infra.project.deploy.new');
import { OnInit, Input, ElementRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-infra-project-deploy-new',
template: templateSource || '',
    styles: [`

/* file: /opt/season-cloud-manager/project/main/build/src/app/portal.infra.project.deploy.new/view.scss */
/* src/app/portal.infra.project.deploy.new/view.scss: no such file or directory */`],
})
export class PortalInfraProjectDeployNewComponent implements OnInit {
    @Input() model: any = null;
    @Input() project: any = {};

    public step: any = 'step1';

    constructor(@Inject( Service) public service: Service,@Inject( ElementRef)  private eRef: ElementRef) { }

    private _docClickBound: any = null;

    public async ngOnInit() {
        await this.service.init();
        this._docClickBound = this._onDocumentClick.bind(this);
        document.addEventListener('click', this._docClickBound, true);
        await this.load();
    }

    ngOnDestroy() {
        if (this._docClickBound) {
            document.removeEventListener('click', this._docClickBound, true);
        }
    }

    private _onDocumentClick(event: MouseEvent) {
        if (!this.eRef.nativeElement.contains(event.target)) {
            this.closeAllIpDropdowns();
        }
    }

    public loading: boolean = false;
    public list: any = [];

    public keyuptime: any = 0

    public search: any = {
        text: "",
        page: 1,
        dump: 40
    }

    public pagination: any = {
        end: -1,
        start: -1,
        current: 0
    }

    public async load(page: number = 1) {
        if (this.loading) return;
        this.loading = true;
        this.pagination.current = page;
        this.search.page = page;
        this.list = [];
        await this.service.render();

        const { code, data } = await wiz.call("search", this.search);

        if (code == 200) {
            let { rows, lastpage } = data;
            const startpage = Math.floor((page - 1) / 10) * 10 + 1;
            this.list = rows;
            this.pagination.start = startpage;
            this.pagination.end = lastpage;
        }

        this.loading = false;
        await this.service.render();
    }

    public async searchAction() {
        let keyuptime: any = new Date().getTime();
        this.keyuptime = keyuptime;
        await this.service.render(500);
        if (this.keyuptime != keyuptime) return;
        await this.load();
    }

    public selected: any;
    public deploy_name: any = "";

    public async select(item) {
        this.selected = item;
        this.step = 'step2';
        await this.service.render();
        await this.info();
    }

    public hosts: any = [];
    public ips: any = [];
    public deploy: any = [];
    public ip_usage: any = {};
    public ipDropdownStyle: any = {};

    public async info() {
        const { code, data } = await wiz.call("info", { id: this.project.id });
        this.hosts = data.hosts;
        this.ips = data.ips;
        this.deploy = data.deploy;
        this.ip_usage = data.ip_usage || {};

        for (let i = 0; i < this.selected.params.length; i++) {
            if (this.selected.params[i].type == 'hostname') {
                this.selected.params[i].value_basehost = '';
                this.selected.params[i].value_name = '';
            }
            if (this.selected.params[i].type == 'ip') {
                this.selected.params[i].value = "";
                this.selected.params[i]._showDropdown = false;
                this.selected.params[i]._searchText = "";
            }
            if (this.selected.params[i].type == 'deploy') {
                this.selected.params[i].value = "";
            }
            if (this.selected.params[i].type == 'list') {
                let desc = this.selected.params[i].description || '';
                let options = desc.split(',').map((s: string) => s.trim()).filter((s: string) => s);
                this.selected.params[i].value = options.length > 0 ? options[0] : '';
            }
        }
        await this.service.render();
    }

    public toggleIpDropdown(item: any, event?: MouseEvent) {
        const wasOpen = item._showDropdown;
        this.closeAllIpDropdowns();
        item._showDropdown = !wasOpen;
        if (item._showDropdown) {
            item._searchText = "";
            if (event) {
                const trigger = (event.currentTarget as HTMLElement);
                const rect = trigger.getBoundingClientRect();
                const dropdownMaxH = 240;
                const spaceBelow = window.innerHeight - rect.bottom;
                const openUpward = spaceBelow < dropdownMaxH && rect.top > dropdownMaxH;
                this.ipDropdownStyle = {
                    position: 'fixed',
                    left: rect.left + 'px',
                    width: rect.width + 'px',
                    'z-index': '99999'
                };
                if (openUpward) {
                    this.ipDropdownStyle['bottom'] = (window.innerHeight - rect.top + 4) + 'px';
                } else {
                    this.ipDropdownStyle['top'] = (rect.bottom + 4) + 'px';
                }
            }
        }
        this.service.render();
    }

    public closeAllIpDropdowns() {
        if (this.selected && this.selected.params) {
            for (let p of this.selected.params) {
                if (p.type === 'ip') p._showDropdown = false;
            }
        }
    }

    public selectIp(item: any, ip: string) {
        item.value = ip;
        item._showDropdown = false;
        this.service.render();
    }

    public getFilteredIps(item: any) {
        const text = (item._searchText || '').toLowerCase();
        if (!text) return this.ips;
        return this.ips.filter((ip: any) => {
            const ipStr = (ip.ip || '').toLowerCase();
            const usedBy = (this.ip_usage[ip.ip] || '').toLowerCase();
            return ipStr.includes(text) || usedBy.includes(text);
        });
    }

    public hostName(host: any): string {
        if (!host) return '';
        if (host.host) return host.host;
        const name = (host.name || '').trim();
        const basehost = (host.basehost || '').trim();
        return name ? `${name}.${basehost}` : basehost;
    }

    public async create() {
        if (!this.deploy_name)
            return await this.service.modal.error(`Input Deploy Name`, false, `Confirm`);

        await this.service.status.show("loading");
        let params = {};

        for (let i = 0; i < this.selected.params.length; i++) {
            let param = this.selected.params[i];
            if (param.type == 'hostname') {
                let value = param.value_basehost;
                if (param.value_basehost) {
                    const subdomain = (param.value_name || '').trim();
                    if (subdomain && subdomain !== '@')
                        value = subdomain + "." + value;
                }
                params[param.name] = value;
            } else if (param.type == 'namespace') {
                params[param.name] = this.project.id;
            } else {
                params[param.name] = param.value ? param.value : '';
            }
        }

        let pd = {
            project_id: this.project.id,
            deploy_id: this.selected.id,
            name: this.deploy_name,
            params: params
        };

        const { code, data } = await wiz.call("create", { data: JSON.stringify(pd) });
        await this.service.status.hide("loading");
        if (code != 200) {
            return await this.service.modal.error(data, false, `Confirm`);
        }
        await this.model.action();
    }

}

export default PortalInfraProjectDeployNewComponent;